import './_vportal.js';

window.addEventListener("load", function () {
  var bannerEl = document.querySelector('.swiper-news-banner');
  if (bannerEl) {
    new Swiper(bannerEl, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-news-banner-pagination",
        clickable: true,
        enabled: true,
      },
      // Switch to arrows on larger screens
      breakpoints: {
        769: {
          
          
        },
      },
    });
  }

  $(".news").each(function () {
    var postsTag = "#" + $(this).attr("id");
    $().vPortal({
      container: postsTag,
      el: {
        tabContainer: '.news-tabs > a',
        resultContainer: '.news-list',
        viewAll: '.viewAll',
      },
      paginationOptions: {
      }
    });

  });

  // Click tab -> đổi ảnh title tương ứng (data-title trên từng tab)
  var titleImg = document.querySelector('#news .title img');
  var tabs = document.querySelectorAll('#news .news-tabs > a');
  function setTitle(tab) {
    if (!titleImg || !tab) return;
    var src = tab.getAttribute('data-title');
    if (src) titleImg.src = src;
  }
  // Đồng bộ title với tab đang active lúc load
  setTitle(document.querySelector('#news .news-tabs > a.active') || tabs[0]);
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      setTitle(tab);
    });
  });
});